import { render, staticRenderFns } from "./RankColumnScore.vue?vue&type=template&id=eb8c8fa6&scoped=true&"
import script from "./RankColumnScore.vue?vue&type=script&lang=ts&"
export * from "./RankColumnScore.vue?vue&type=script&lang=ts&"
import style0 from "./RankColumnScore.vue?vue&type=style&index=0&id=eb8c8fa6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb8c8fa6",
  null
  
)

export default component.exports